var _defs, _style, _use, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    width: 600,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 600,
    height: 600,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAlgAAAJYAQMAAACEqAqfAAAAAXNSR0IB2cksfwAAAANQTFRF////p8QbyAAAAENJREFUeJztwQENAAAAwqD3T20ON6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAL4NsiAAAfkdBQsAAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m205.7 287.3q11.9 0 19.6 6.7 7.9 6.6 7.9 20 0 13.6-8.4 22.3-8.3 8.5-23.1 8.5-12.8 0-21.6-6.4-8.7-6.5-9.9-17.2h10.2q2.5 13.8 21.3 13.8 6 0 10.2-1.8 4.3-1.8 6.6-4.9 2.2-3.2 3.2-6.7 1-3.5 1-7.6 0-18.5-19.8-18.5-6.8 0-12.9 3.4-5.8 3.4-9.1 7.6h-9.1l6.9-48.5h49.8v10.1h-42.8l-3.8 27.3q8.4-8.1 23.8-8.1zm75.2-1.6q13.3 0 21.3 7.6 8 7.6 8 21.1 0 14.7-9.4 22.4-9.3 7.7-22.4 7.7-14 0-22.3-7.9-10.6-9.8-10.6-34.3 0-23.3 8.5-34.8 8.7-11.6 24.8-11.6 11.8 0 20.3 5.8 8.5 5.7 9.5 15.8h-10.2q-1-5.3-5.7-8.7-4.8-3.5-13.9-3.5-13.3 0-19 8.7-5.8 8.5-5.8 26.7v0.2q2.3-7.6 9.7-11.4 7.4-3.8 17.2-3.8zm-2.5 49q10.3 0 16.4-5.3 6.1-5.4 6.1-14.8 0-9.1-5.6-14.6-5.6-5.6-15.2-5.6-10.7 0-17.3 5.8-6.4 5.6-6.4 14.9 0 8.9 6 14.3 6.2 5.3 16 5.3zm62.3-41q-8 0-13.3-5.3-5.2-5.3-5.2-13.3 0-7.8 5.2-13.2 5.3-5.3 13.3-5.3 7.8 0 13.1 5.3 5.4 5.4 5.4 13.2 0 7.8-5.4 13.3-5.3 5.3-13.1 5.3zm-8.6-10.1q3.4 3.3 8.6 3.3 5.2 0 8.4-3.3 3.2-3.3 3.2-8.5 0-5.2-3.2-8.4-3.2-3.2-8.4-3.2-5.2 0-8.6 3.2-3.2 3.2-3.2 8.4 0 5.2 3.2 8.5zm50 23.1v36.3h-10.5v-85h57.8v9.8h-47.3v29.1h44.3v9.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.d84f14e27759bd4bf48967f625e767b7.svg";
export { ForwardRef as ReactComponent };